// Default starter JSON shown in the "Add Visual JSON" editor, keyed by element json type.

/** Default element_json for type === 'filter'. */
export const FILTER_ELEMENT_DEFAULT_JSON = {
  fields: [
    {
      label: '<field Label>',
      type: 'hierarchal',
      name: '<unique_filter_key>',
      column: {
        '<Parent Label>': '<PARENT_ID_OR_NAME_ALIAS>',
        '<Child Label>': '<CHILD_ID_OR_NAME_ALIAS>'
      },
      default_selection: 'None',
      visibility: true,
      class: '<field-width>',
      search: 'like'
    },
    {
      label: '<Filter Label shown in UI>',
      type: 'multiselect',
      name: {
        '<Source_Column_Or_Alias>': '<Filter_Column_Alias>'
      },
      default_selection: 'All',
      visibility: true,
      class: '<field-width>',
      search: 'like'
    },
    {
      label: '<Filter Label shown in UI>',
      type: 'hierarchal-delimiter',
      splitClause: '<row-delimiter> :: <parent-child-delimiter>',
      name: {
        '<Source_Column_Or_Alias>': '<Filter_Column_Alias>'
      },
      default_selection: 'All',
      visibility: true,
      class: '<field-width>',
      search: 'like'
    }
  ],
  query_filter: {
    declarekey: '',
    tablekey: {
      main: '[<schema>].[<table_or_view_name>] A'
    },
    columnList: {
      main: [
        'A.[<column_1>]',
        'A.[<column_2>]',
        'A.[<column_n>]'
      ]
    },
    whereList: {
      main: []
    },
    constraints: [],
    columnkey: {
      'A.[<column_1>]': '[<Alias_1>]',
      'A.[<column_2>]': '[<Alias_2>]',
      'A.[<column_n>]': '[<Alias_n>]'
    },
    baseWhere: '',
    defaultQuery: ''
  }
};

/** Default element_json for all non-filter visual types (table, metrics, charts, etc.). */
export const OTHER_ELEMENT_DEFAULT_JSON = {
  declarekey: '<Optional T-SQL DECLARE/SET block for runtime variables, e.g. \'DECLARE @cost_year INT; SELECT TOP 1 @cost_year=[year] FROM dbo.<LookupTable> ORDER BY [year] DESC;\' — use "" if not needed>',

  columnkey: {
    "''": '[<Static literal column alias, e.g. Update_Type(U)>]',
    'A.[<Main_Column_1>]': '[<Display Name 1>]',
    'A.[<Main_Column_2>]': '[<Display Name 2>]',
    'B.[<Joined_Column_1>]': '[<Display Name From Joined Table>]',
    'A.[<Column_With_Runtime_Var>]': '[<Display Name @your_declared_var>]'
  },

  tablekey: {
    main: '[<schema>].[<main_table_or_view>] A',
    source2: '[<schema>].[<second_table_or_view>] B'
  },

  columnList: {
    main: [
      'A.[<Main_Column_1>]',
      'A.[<Main_Column_2>]',
      'A.[<Join_Key_Column>]'
    ],
    source2: [
      'B.[<Join_Key_Column>] AS <JoinAliasName>',
      'B.[<Joined_Column_1>]',
      'B.[<Joined_Column_2>]'
    ]
  },
  whereList: {
    main: ['<put condition for cte table like (id>5)>'],
    source2: []
  },

  constraints: [
    'INNER JOIN CTE2 B ON A.<Join_Key_Column> = B.<JoinAliasName>'
  ],

  baseWhere: "( B.[<Visibility_Column>] = 'Public' OR ( B.[<Visibility_Column>] = 'Private' AND ( B.[<Owner_Column>] = ':userEmail' OR B.[<Secondary_Owner_Column>] like '%:userEmail%' OR B.[<Delegate_Column>] like '%:userEmail%' ) ) )",

  conditions: 'WHERE :: A.[<Filter_Column_On_Main>] IN :: string :: AND :: B.[<Filter_Column_On_Joined>] IN :: string',

  totalCount: 'COUNT(A.[<Unique_Key_Column>]) AS TotalCount',

  defaultQuery: 'ORDER BY A.<Unique_Key_Column>',

  applied_filter: [
    '<filter field \'name\' targeting the joined table, e.g. Group>',
    '<filter field name targeting the main table>',
    'attributes'
  ],

  isAttributeVisibile: true,

  defaultAttributeSelection: [
    '<Display Name 1>',
    '<Display Name From Joined Table>'
  ]
};
